<template>
    <div class="or-admin-save-button flex-row flex-center hover-pointer anim-admin-save" @click="save">
        <p class="text">Сохранить</p>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    props: {
        options: Object,
        selected_page: String,
        deleted: Object,
    },
    methods: {
        ...mapActions({setToDB: 'setToDB', removeUnsavedPage: 'removeUnsavedPage'}),
        async save() {
            let content;
            switch (this.selected_page) {
                case 'main':
                case 'contacts':
                case 'info':
                    content = {};
                    for (const key in this.options) {
                        content[key] = this.options[key].value;
                    };
                    try {
                        await this.setToDB({table: 'site_info', content})
                        .then(()=>{
                            this.removeUnsavedPage({page: 'main'});
                            this.removeUnsavedPage({page: 'contacts'});
                            this.removeUnsavedPage({page: 'info'});
                        });
                    } catch(error) {
                        return;
                    };
                    break;
                case 'news': 
                    content = [];
                    this.options.map(el=>{
                        content.push({
                            id: el.id,
                            title: el.title.value,
                            text: el.text.value,
                            date: el.date.value,
                        })
                    });
                    try {
                        await this.setToDB({table: 'news', content, deleted: this.deleted.news})
                        .then(()=>{
                            this.removeUnsavedPage({page: 'news'});
                            this.deleted.length = 0;
                        });
                    } catch(error) {
                        return;
                    };
                    break;
                case 'about': 
                    try {
                        await this.setToDB({table: 'about', content: this.options})
                        .then(()=>{
                            this.removeUnsavedPage({page: 'about'});
                        });
                    } catch(error) {
                        return;
                    };
                    break;
                case 'buyers':
                    content = [];
                    this.options.map((el, index)=>{
                        content.push({
                            id: el.id,
                            category: el.value,
                            image: el.image,
                            position: index,
                            sort: {sort: el.products_sort},
                        })
                    })
                    try {
                        await this.setToDB({table: 'buyers', content, deleted: this.deleted.buyers})
                        .then(()=>{
                            this.removeUnsavedPage({page: 'buyers'});
                            this.deleted.length = 0;
                        });
                    } catch(error) {
                        return;
                    };
                    break;
                case 'production':
                    content = [];
                    this.options.map((el, index)=>{
                        content.push({
                            id: el.id,
                            category: el.value,
                            image: el.image,
                            position: index,
                            sort:  {sort: el.products_sort},
                        })
                    })
                    try {
                        await this.setToDB({table: 'production', content, deleted: this.deleted.production})
                        .then(()=>{
                            this.removeUnsavedPage({page: 'production'});
                            this.deleted.length = 0;
                        });
                    } catch(error) {
                        return;
                    };
                break;
                case 'products': 
                    content = [];
                    this.options.map((el, index)=>{
                        content.push({
                            id: el.id,
                            name: el.title.value,
                            content: el.content,
                            image: el.image,
                            description: el.description.value,
                            production_category_id: el.production_category_id,
                            buyers_category_id: el.buyers_category_id,
                        })
                    })
                    try {
                        await this.setToDB({table: 'products', content, deleted: this.deleted.products}) 
                        .then(()=>{
                            this.removeUnsavedPage({page: 'products'});
                            this.deleted.length = 0;
                        });
                    } catch(error) {
                        return;
                    };
                break;
            }
        }
    }
}
</script>

<style scoped>
    .or-admin-save-button {
        position: absolute;
        right: 40px;
        top: 35px;
        width: 160px;
        height: 42px;
        background-color: #3DC986;
        border-radius: 8px;
        color: white;
    }
    .text {
        font-size: 14px;
        height: 16px;
    }
</style>